function googleMapsScriptAlreadyExists() {
  return document.getElementById('gmaps-script')
}

export function loadGoogleMapsScript(callback) {
  if (googleMapsScriptAlreadyExists()) {
    return callback()
  }
  const apiKey = window.renaultRent.google_key

  window.googleMapsCallBack = callback

  const tag = document.createElement('script');

  tag.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=googleMapsCallBack`;
  const firstScriptTag = document.getElementsByTagName('script')[0];
  tag.id = 'gmaps-script'
  return firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

export default {
  loadGoogleMapsScript,
}
